/* eslint-disable react/jsx-props-no-spreading */

import React, { InputHTMLAttributes } from 'react';
import InputWrapper from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
	label?: string;
	errorMessage?: string;
	customErrorMessage?: string;
	onBlur?: (data: any) => void;
	fireValidationOnBlur?: () => void;
	direction?: 'rtl' | 'ltr';
}

const Input: React.FC<InputProps> = ({
	label,
	errorMessage,
	customErrorMessage,
	onBlur,
	fireValidationOnBlur,
	direction = 'rtl',
	...rest
}) => {
	return (
		<InputWrapper
			className='input'
			$hasError={!!errorMessage || !!customErrorMessage}
			$direction={direction}
		>
			{label && rest.id && (
				<label className='label' htmlFor={rest.id}>
					{label}
				</label>
			)}
			<input
				{...rest}
				onBlur={(event: any) => {
					if (onBlur) {
						onBlur(event);
					}
					if (fireValidationOnBlur) {
						fireValidationOnBlur();
					}
				}}
			/>
			{(!!errorMessage || !!customErrorMessage) && (
				<span className='error-message'>
					{errorMessage || customErrorMessage}
				</span>
			)}
		</InputWrapper>
	);
};

Input.defaultProps = {
	label: '',
};

export default Input;
